import { IconProps } from "./types";

export default function IcoTv({
	color = "#4B5563",
	width = "20",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 16"
			fill="none"
		>
			<g clipPath="url(#clip0_641_1093)">
				<path
					d="M2 2V11H18V2H2ZM0 2C0 0.896875 0.896875 0 2 0H18C19.1031 0 20 0.896875 20 2V11C20 12.1031 19.1031 13 18 13H2C0.896875 13 0 12.1031 0 11V2ZM4 14H16C16.5531 14 17 14.4469 17 15C17 15.5531 16.5531 16 16 16H4C3.44688 16 3 15.5531 3 15C3 14.4469 3.44688 14 4 14Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_641_1093">
					<path d="M0 0H20V16H0V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
